<template>
    <div class="errorPage">
        <Head>
            <Title>Mark Done - Error</Title>
        </Head>
        <div class="cover">
            <h1>{{ error?.statusCode }} ERROR</h1>
            <p>{{ error?.statusCode.toString().startsWith('4') ? `It looks like the issue is on your end. We couldn't find the page you're looking for.` : `Don't worry, it's not your fault—it's us! Please use the buttons below to safely navigate back.` }}</p>
            <div class="actBtns">
                <button @click="handleError">Go Home</button>
                <a href="mailto:markdonetasks@gmail.com" >Contact Mark Done</a>
            </div>
        </div>
        <img src="/images/error.png" alt="mark done error image">
    </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
    error: Object as () => NuxtError
})

console.log(props.error)
const handleError = () => clearError({ redirect: '/' })

</script>

<style lang="scss" scoped>
.errorPage {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10% 5%;

    img {
        max-width: 700px;
        width: 100%;
        height: 100%;
    }

    .cover {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        margin-bottom: 5rem;

        h1 {
            font-size: 4rem;
            margin-bottom: 1rem;
            /* font-size: 3rem; */
        }

        p {
            max-width: 550px;
        }

        .actBtns {
            margin-top: 2rem;
            display: flex;
            align-items: center;


            button {
                border: none;
                margin: 0.5rem;
                padding: 1rem 2.5rem;
                margin-left: 0;
                background-color: var(--dark-theme);
                color: #fff;
                cursor: pointer;
                border-radius: var(--main-radius);
            }
            a {
                border: 2px solid var(--dark-theme);
                color: var(--dark-theme);
                text-decoration: none;
                padding: 0.7rem 2.5rem;
                border-radius: var(--main-radius);
            }
        }
    }
}

@media (prefers-color-scheme: dark) {
    .errorPage {
        .cover {
            color: #fff;
            p {
                color: #eee;
            }
            .actBtns {
                button {
                    background-color: var(--light-theme);
                    color: #000;
                }
                a {
                    border: 2px solid var(--light-theme);
                    color: var(--light-theme);
                }
            }
        }
    }
}

</style>